import axios from '../axiosConfig';

function trimTrailingSlash(value = ''): string {
  return value.replace(/\/+$/, '');
}

function getApiBaseUrl(apiBaseUrl?: string | null): string {
  return trimTrailingSlash(apiBaseUrl || axios.defaults.baseURL || process.env.REACT_APP_API_URL || '');
}

function getApiOrigin(apiBaseUrl?: string | null): string {
  const normalizedBaseUrl = getApiBaseUrl(apiBaseUrl);

  if (!/^https?:\/\//i.test(normalizedBaseUrl)) {
    return '';
  }

  return normalizedBaseUrl.replace(/\/api$/i, '');
}

export function isProbablyBase64Image(value: string): boolean {
  if (!value) return false;
  const trimmed = value.trim();
  if (trimmed.startsWith('data:')) return true;

  const head = trimmed.slice(0, 20);
  return head.startsWith('/9j/')
    || head.startsWith('iVBOR')
    || head.startsWith('R0lGOD')
    || head.startsWith('UklGR');
}

function inferMimeFromBase64(value: string): string {
  const head = value.trim().slice(0, 20);
  if (head.startsWith('/9j/')) return 'image/jpeg';
  if (head.startsWith('iVBOR')) return 'image/png';
  if (head.startsWith('R0lGOD')) return 'image/gif';
  if (head.startsWith('UklGR')) return 'image/webp';
  return 'image/jpeg';
}

export function toDataUrlFromBase64(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('data:')) return trimmed;
  return `data:${inferMimeFromBase64(trimmed)};base64,${trimmed}`;
}

export function resolveApiAssetUrl(value?: string | null, apiBaseUrl?: string | null): string | null {
  if (!value || !value.trim()) {
    return null;
  }

  const trimmed = value.trim();

  if (isProbablyBase64Image(trimmed)) {
    return toDataUrlFromBase64(trimmed);
  }

  if (/^(https?:|blob:)/i.test(trimmed)) {
    return trimmed;
  }

  if (trimmed.startsWith('/api/')) {
    const apiOrigin = getApiOrigin(apiBaseUrl);
    return apiOrigin ? `${apiOrigin}${trimmed}` : trimmed;
  }

  if (trimmed.startsWith('/')) {
    return trimmed;
  }

  return null;
}
